"use strict";

const { Linter } = require("./linter");
const interpolate = require("./interpolate");
const SourceCodeFixer = require("./source-code-fixer");

module.exports = {
    Linter,

    // For testers.
    SourceCodeFixer,
    interpolate
};
